import { render, staticRenderFns } from "./_record.vue?vue&type=template&id=0001ce78&scoped=true"
import script from "./_record.vue?vue&type=script&lang=js"
export * from "./_record.vue?vue&type=script&lang=js"
import style0 from "./_record.vue?vue&type=style&index=0&id=0001ce78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001ce78",
  null
  
)

export default component.exports